import { ZipCodeFilterState } from '../../FilterStore'
import { FilterChipCloseButton, FilterChipContainer } from './FilterChipStyles'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

export type FilterZipRangeProps = {
  label: string
  active: ZipCodeFilterState
  onClose?: () => void
  isExclusive: boolean
  isHovered?: boolean
}

export function FilterChipZipRange({
  label,
  active,
  onClose,
  isExclusive,
  isHovered,
}: FilterZipRangeProps) {
  const variant = useTableLinkVariant()
  const isPlain = variant === 'plain'
  const getFormattedValue = () => {
    // The saved-filter payload is untyped (SavedView.payload: Record<any, any>)
    // and legacy rows can persist the zip list as a bare string instead of a
    // string[] ("string from legacy URLs" — see parseFlatFiltersToStore in
    // FilterStore.ts). Coerce to an array so .join never throws and takes down
    // the whole settings page.
    const raw = active?.[0]
    const zips = Array.isArray(raw) ? raw : raw != null ? [raw] : []
    const range = active?.[1]
    const zipLabel = zips.join(', ')
    if (range != null) {
      return `${zipLabel} (${range} mile${range > 1 ? 's' : ''})`
    }
    return zipLabel
  }

  return (
    <FilterChipContainer
      $isExclusive={isPlain ? false : isExclusive}
      isHovered={isHovered}
    >
      <span>
        {`${label}: `}
        {isPlain && isExclusive ? <b>NOT </b> : null}
        <b>{getFormattedValue()}</b>
      </span>
      {onClose && (
        <FilterChipCloseButton
          $isExclusive={isPlain ? false : isExclusive}
          onClick={onClose}
        />
      )}
    </FilterChipContainer>
  )
}
